/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CandidateCreateDTO } from '../models/CandidateCreateDTO'
import type { ResendConfirmationDTO } from '../models/ResendConfirmationDTO'
import type { CancelablePromise } from '../core/CancelablePromise'
import { OpenAPI } from '../core/OpenAPI'
import { request as __request } from '../core/request'
export class AspenCreateCandidatesService {
    /**
     * Create
     * Create a new Aspen Patient Candidate.
     * @returns any Successful Response
     * @throws ApiError
     */
    public static createCandidatesPost({ requestBody }: { requestBody: CandidateCreateDTO }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/aspen/candidates',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`
            }
        })
    }
    /**
     * Resend Confirmation
     * Re-queue the registration confirmation email for an existing candidate.
     * Unauthenticated endpoint, rate limited to 3 requests per IP per hour.
     * @returns string Successful Response
     * @throws ApiError
     */
    public static resendConfirmationCandidatesResendConfirmationPost({
        requestBody
    }: {
        requestBody: ResendConfirmationDTO
    }): CancelablePromise<Record<string, string>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/aspen/candidates/resend-confirmation',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`
            }
        })
    }
}
